const PageMain = (props) => {
	return <div className="page-main">{props.children}</div>;
};

export default PageMain;
